module.exports = __webpack_public_path__ + "img/service-six-three.4e85fa7d.svg";